import { useEffect } from 'react';
import { batch } from 'react-redux';
import { useAppDispatch } from '../../../../redux/hooks';
import { clearAllAnalysesAction } from '../../../../redux/slices/analyses';
import { resetBuilder } from '../../../../redux/slices/oldBuilder';

/**
 * This hook will handle everything what should be done when
 * user navigates to other than create cohort page
 *
 * Perform clean-ups here
 */
const useUnmountCreateCohortEffect = () => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    return () => {
      batch(() => {
        dispatch(resetBuilder());
        dispatch(clearAllAnalysesAction());
      });
    };
  }, [dispatch]);

  return null;
};

export default useUnmountCreateCohortEffect;
